import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _Number$isNaN from "@babel/runtime-corejs3/core-js-stable/number/is-nan";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import React, { useContext, useState, useEffect, useRef, useMemo, useCallback } from 'react';
import ConfigContext from '../config-provider/ConfigContext';
import Trigger from './trigger';
import classNames from 'classnames';
import { getCompProps } from '../_utils';
import { tuple } from '../_utils/type';
import devWarning from '../_utils/devwarning';
export var SplitPanelModes = tuple('horizontal', 'vertical');

function pxToScale(numerator, denominator) {
  var percent = parseFloat(numerator) / parseFloat(denominator);
  return calcNumber(percent);
}

function calcNumber(value) {
  if (value > 1) return 1;
  if (value < 0) return 0;
  return value;
}

function valueIsNaN(value) {
  return _Number$isNaN(parseFloat(value));
}

var SplitPanel = function SplitPanel(props) {
  var _context;

  var _useContext = useContext(ConfigContext),
      getPrefixCls = _useContext.getPrefixCls,
      prefixCls = _useContext.prefixCls,
      userDefaultProps = _useContext.compDefaultProps;

  var splitPanelProps = getCompProps('SplitPanel', userDefaultProps, props); // props

  var customPrefixcls = splitPanelProps.prefixCls,
      className = splitPanelProps.className,
      style = splitPanelProps.style,
      disabled = splitPanelProps.disabled,
      defaultSplit = splitPanelProps.defaultSplit,
      mode = splitPanelProps.mode,
      lineStyle = splitPanelProps.lineStyle,
      min = splitPanelProps.min,
      max = splitPanelProps.max,
      firstSlot = splitPanelProps.firstSlot,
      secondSlot = splitPanelProps.secondSlot,
      canFold = splitPanelProps.canFold,
      foldIcons = splitPanelProps.foldIcons,
      onFold = splitPanelProps.onFold,
      onMoving = splitPanelProps.onMoving,
      onMoveStart = splitPanelProps.onMoveStart,
      onMoveEnd = splitPanelProps.onMoveEnd;
  devWarning(SplitPanelModes.indexOf(mode) === -1, 'split-panel', "cannot found split-panel mode '".concat(mode, "'"));
  devWarning(valueIsNaN(defaultSplit), 'split-panel', "incorrect prop 'defaultSplit'");
  var splitPanelPrefixCls = getPrefixCls(prefixCls, 'split', customPrefixcls);
  var isHorizontal = mode === 'horizontal';
  var offsetSizeProperty = isHorizontal ? 'clientWidth' : 'clientHeight';
  var pos = isHorizontal ? 'left' : 'top';
  var oppositePos = isHorizontal ? 'right' : 'bottom';
  var oppositeMode = isHorizontal ? 'vertical' : 'horizontal';
  var outerWrapper = useRef(null);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isMoving = _useState2[0],
      setIsMoving = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      offset = _useState4[0],
      setOffset = _useState4[1];

  var _useState5 = useState(100),
      _useState6 = _slicedToArray(_useState5, 2),
      anotherOffset = _useState6[0],
      setAnotherOffset = _useState6[1];

  var _useState7 = useState(0),
      _useState8 = _slicedToArray(_useState7, 2),
      computeMin = _useState8[0],
      setComputeMin = _useState8[1];

  var _useState9 = useState(100),
      _useState10 = _slicedToArray(_useState9, 2),
      computeMax = _useState10[0],
      setComputeMax = _useState10[1];

  var _useState11 = useState(0),
      _useState12 = _slicedToArray(_useState11, 2),
      offsetCache = _useState12[0],
      setOffsetCache = _useState12[1];

  var isFirstPanelHide = offset === 0;
  var isSecondPanelHide = offset === 100;
  var canDrag = offset >= computeMin && offset <= computeMax;
  useEffect(function () {
    setAnotherOffset(100 - offset);
  }, [offset]); // 将defaultOffset转换成百分比

  var getComputeOffset = useCallback(function (value) {
    var newVal = typeof value === 'string' ? pxToScale(value, outerWrapper.current[offsetSizeProperty]) : calcNumber(value);
    return newVal * 100;
  }, [offsetSizeProperty]); // 将min和max转换为百分比

  var getComputedThresholdValue = useCallback(function (val) {
    var size = outerWrapper.current[offsetSizeProperty];
    var newVal = typeof val === 'string' ? pxToScale(val, size) : calcNumber(val);
    return newVal * 100;
  }, [offsetSizeProperty]); // 初始化分割线、min和max

  var initPanel = useCallback(function () {
    var thresholdMin = getComputedThresholdValue(min);
    var thresholdMax = 100 - getComputedThresholdValue(max);
    var computeOffset = getComputeOffset(defaultSplit); // 边界处理，计算出的min和max进行判断

    if (thresholdMin > thresholdMax) {
      thresholdMin = thresholdMax;
    } // 计算出的offset值的边界处理


    if (computeOffset < thresholdMin) {
      computeOffset = thresholdMin;
    } else if (computeOffset > thresholdMax) {
      computeOffset = thresholdMax;
    }

    setOffset(computeOffset);
    setOffsetCache(computeOffset);
    setComputeMin(thresholdMin);
    setComputeMax(thresholdMax);
  }, [min, max, defaultSplit, getComputedThresholdValue, getComputeOffset]);
  useEffect(function () {
    initPanel();
  }, [initPanel]);
  var handleMove = useCallback(function (e) {
    // 将鼠标移动距离与offset进行处理
    var scrollX = document.documentElement.scrollLeft || document.body.scrollLeft;
    var scrollY = document.documentElement.scrollTop || document.body.scrollTop;
    var wrapperOffset = outerWrapper.current.getBoundingClientRect()[pos];
    var mouseOffset = isHorizontal ? e.pageX - scrollX : e.pageY - scrollY;
    var moveInstance = mouseOffset - wrapperOffset;
    var outerWidth = outerWrapper.current[offsetSizeProperty];
    var value = pxToScale(moveInstance, outerWidth) * 100; // 边界阈值处理

    if (value <= computeMin) value = Math.max(value, computeMin);
    if (value >= computeMax) value = Math.min(value, computeMax);
    setOffset(value);
    setOffsetCache(value);
    onMoving && onMoving(e);
  }, [pos, offsetSizeProperty, isHorizontal, onMoving, computeMin, computeMax]);
  var handleUp = useCallback(function (e) {
    setIsMoving(false);
    document.removeEventListener('mouseup', handleUp);
    document.removeEventListener('mousemove', handleMove);
    onMoveEnd && onMoveEnd(e);
  }, [handleMove, onMoveEnd]);
  var handleMousedown = useCallback(function (e) {
    if (disabled || !canDrag) return;
    e.stopPropagation();
    setIsMoving(true);
    document.addEventListener('mousemove', handleMove);
    document.addEventListener('mouseup', handleUp);
    onMoveStart && onMoveStart(e);
  }, [disabled, canDrag, handleMove, handleUp, onMoveStart]);
  var changeSplit = useCallback(function (offset) {
    setOffset(offset);
  }, []);

  var getSecondHideOffset = function getSecondHideOffset() {
    if (offset === 0 && computeMin > 0) {
      return computeMin;
    } else if (offset >= computeMin && offset < offsetCache) {
      return offsetCache;
    } else {
      return 100;
    }
  };

  var getFirstHideOffset = function getFirstHideOffset() {
    if (offset === 100 && computeMax < 100) {
      return computeMax;
    } else if (offset > offsetCache && offset <= computeMax) {
      return offsetCache;
    } else {
      return 0;
    }
  }; // 折叠第一个面板


  var hideFirstPanel = function hideFirstPanel(e, direction) {
    if (disabled) return;
    e.persist();
    var pos = getFirstHideOffset();
    changeSplit(pos);
    onFold && onFold(e, direction);
  }; // 折叠第二个面板


  var hideSecondPanel = function hideSecondPanel(e, direction) {
    if (disabled) return;
    e.persist();
    var pos = getSecondHideOffset();
    changeSplit(pos);
    onFold && onFold(e, direction);
  }; // 处理lineStyle


  var handleLineStyle = useCallback(function (mode) {
    if (typeof lineStyle === 'function') {
      return lineStyle(mode);
    }

    return lineStyle;
  }, [lineStyle]);
  var triggerLineStyle = useMemo(function () {
    return {
      horizontal: handleLineStyle('horizontal') || {},
      vertical: handleLineStyle('vertical') || {}
    };
  }, [handleLineStyle]); // 处理自定义折叠图标

  var handleFoldIcons = useCallback(function (mode) {
    if (typeof foldIcons === 'function') {
      return foldIcons(mode);
    }

    return foldIcons;
  }, [foldIcons]);
  var triggerFoldIcons = useMemo(function () {
    return {
      horizontal: handleFoldIcons('horizontal'),
      vertical: handleFoldIcons('vertical')
    };
  }, [handleFoldIcons]);
  var cls = classNames("".concat(splitPanelPrefixCls, "-wrapper"), {
    'no-select': isMoving
  }, className);

  var getPanelCls = function getPanelCls(cls) {
    return classNames("".concat(splitPanelPrefixCls, "-panel"), _defineProperty({}, "".concat(splitPanelPrefixCls, "-panel-moving"), isMoving), "".concat(cls, "-panel"));
  };

  var triggerWrapperCls = classNames("".concat(splitPanelPrefixCls, "-trigger-con"), {
    'can-drag': canDrag,
    'is-disabled': disabled,
    'is-active': isFirstPanelHide || isSecondPanelHide
  });
  return /*#__PURE__*/React.createElement("div", {
    className: cls,
    style: style,
    ref: outerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: _concatInstanceProperty(_context = "".concat(splitPanelPrefixCls, "-")).call(_context, mode)
  }, /*#__PURE__*/React.createElement("div", {
    className: getPanelCls(pos),
    style: _defineProperty({}, oppositePos, "".concat(anotherOffset, "%"))
  }, firstSlot), /*#__PURE__*/React.createElement("div", {
    className: triggerWrapperCls,
    style: _defineProperty({}, pos, "".concat(offset, "%"))
  }, /*#__PURE__*/React.createElement(Trigger, {
    style: triggerLineStyle[mode],
    mode: oppositeMode,
    prefixCls: splitPanelPrefixCls,
    disabled: disabled,
    showFoldIcons: canFold,
    hideFirstPanel: hideFirstPanel,
    hideSecondPanel: hideSecondPanel,
    foldIcons: triggerFoldIcons[mode],
    handleMousedown: handleMousedown
  })), /*#__PURE__*/React.createElement("div", {
    className: getPanelCls(oppositePos),
    style: _defineProperty({}, pos, "".concat(offset, "%"))
  }, secondSlot)));
};

SplitPanel.displayName = 'SplitPanel';
export default SplitPanel;